import { render, staticRenderFns } from "./requestChangeEmail.vue?vue&type=template&id=67fd5aa9"
import script from "./requestChangeEmail.ts?vue&type=script&lang=js&external"
export * from "./requestChangeEmail.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports